
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import FormField from '@/components/forms/FormField.vue';

import {
  Actions as TemplateActions,
  Getters as TemplateGetters,
} from '@/store/enums/TemplateEnums';
import { MailingList } from '@/models/MailingListModel';

/**
 * TODO:
 *
 * Recreate this component when the backend start creating auto-generated
 * passwords
 */

export default defineComponent({
  name: 'mailing-list-select',
  components: {
    FormField,
  },
  emits: ['change', 'close'],
  props: {
    containerClass: {
      default: 'col-lg-4',
      type: String,
    },
    name: {
      default: 'template',
      type: String,
    },
    label: {
      default: 'Template',
      type: String,
    },
    value: {
      default: '',
      type: String,
    },
    options: {
      default: null,
      type: Array,
    },
  },
  data: () => ({
    mailingListOptions: [] as unknown as Array<MailingList>,
  }),
  mounted() {
    this.loadList();
  },
  computed: {
    ...mapGetters({
      mailingLists: TemplateGetters.GET_MAILING_LIST,
    }),
  },
  methods: {
    ...mapActions({
      fetchMailList: TemplateActions.FETCH_MAILING_LIST,
    }),
    async loadList() {
      await this.fetchMailList().then(() => {
        this.handleSortMailListOptions();
      });
    },
    handleChange(value) {
      this.$emit('change', value);
    },
    handleClose() {
      this.$emit('close');
    },

    async handleSortMailListOptions() {
      let mailOptions = [] as any;

      if (typeof this.mailingLists !== 'undefined') {
        this.mailingLists.map((mailList) => {
          mailOptions.push({
            value: mailList.system_name,
            label: mailList.name,
          });
        });

        await mailOptions.sort((a, b) => {
          let fa = a.label.toLowerCase(),
            fb = b.label.toLowerCase();

          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
          return 0;
        });
      }

      this.mailingListOptions = mailOptions;
    },
  },
});
